import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/CrosshairSimple.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(a, { ref: s, ...e, weights: i }));
r.displayName = "CrosshairSimpleIcon";
const p = r;
export {
  p as CrosshairSimple,
  r as CrosshairSimpleIcon
};
